import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: '[nc-access-denied]',
  templateUrl: './access-denied.component.html',
  standalone: false,
})
export class AccessDeniedComponent {
  @Output() isAccessDeniedOkClicked = new EventEmitter<boolean>();

  onOkButtonClicked(): void {
    this.isAccessDeniedOkClicked.emit(true);
  }
}
